import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { getAffiliationId, editAffiliation } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import AffiliationForm from 'components/backoffice/forms/affiliationForm';

const EditAffiliation = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const { setTitle } = useOutletContext();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [affiliation, setAffiliation] = useState(null);

  useEffect(() => {
    setTitle(t('editAffiliation'));
    const fetchAffiliation = async () => {
      try {
        setLoading(true);
        const data = await getAffiliationId(id);
        setAffiliation(data.data);
      } catch (error) {
        toast.error(t('mensajeerror'), { theme: 'colored' });
      } finally {
        setLoading(false);
      }
    };
    fetchAffiliation();
    return () => {
      setTitle('');
    };
  }, [id, t, setTitle]);

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      name: values.name,
      address: values.address,
      phone: values.phone,
      email: values.email,
      request_description: values.request_description,
      status: values.status,
    };
    try {
      const { status } = await editAffiliation(id, data);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/affiliation-request', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      toast.error(t('mensajeerror'), { theme: 'colored' });
    }
    setLoading(false);
  }, [id, t, navigate]);

  return (
    <div className="affiliation-edit mt-5">
      <Title text={t('editAffiliation')} />
      <AffiliationForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        defaultValues={affiliation}
        beforeTitle={t('editAffiliation')}
      />
    </div>
  );
};

export default EditAffiliation;